<template>
  <div class="github-contributions">
    <div class="mb-2 flex items-center justify-between sm:mb-3">
      <p class="text-xs font-medium text-flax-smoke-300 sm:text-sm">GitHub Activity</p>
      <a 
        :href="`https://github.com/${username}`" 
        target="_blank"
        class="text-[10px] text-flax-smoke-400 transition-colors hover:text-flax-smoke-200 sm:text-xs"
      >
        @{{ username }}
      </a>
    </div>
    
    <div class="contribution-graph overflow-hidden rounded-lg border border-flax-smoke-500/30 bg-flax-smoke-950/50 p-3 backdrop-blur-sm sm:p-4">
      <img 
        :src="githubContributionUrl" 
        alt="GitHub Contributions"
        class="w-full rounded"
        loading="lazy"
      />
      
      <div class="mt-3 grid grid-cols-2 gap-2 border-t border-flax-smoke-500/20 pt-3 sm:gap-3">
        <div class="text-center">
          <p class="text-[10px] text-flax-smoke-400 sm:text-xs">This Year</p>
          <p class="text-base font-bold text-flax-smoke-200 sm:text-lg">{{ stats.thisYear }}</p>
        </div>
        <div class="text-center">
          <p class="text-[10px] text-flax-smoke-400 sm:text-xs">Longest Streak</p>
          <p class="text-base font-bold text-flax-smoke-200 sm:text-lg">{{ stats.longestStreak }} days</p>
        </div>
      </div>
      
      <div class="mt-2 flex items-center justify-end gap-1.5 text-[10px] text-flax-smoke-400 sm:gap-2 sm:text-xs">
        <span class="hidden sm:inline">Less</span>
        <div class="flex gap-0.5 sm:gap-1">
          <div class="h-2.5 w-2.5 rounded-sm bg-[#161b22] sm:h-3 sm:w-3"></div>
          <div class="h-2.5 w-2.5 rounded-sm bg-[#0e4429] sm:h-3 sm:w-3"></div>
          <div class="h-2.5 w-2.5 rounded-sm bg-[#006d32] sm:h-3 sm:w-3"></div>
          <div class="h-2.5 w-2.5 rounded-sm bg-[#26a641] sm:h-3 sm:w-3"></div>
          <div class="h-2.5 w-2.5 rounded-sm bg-[#39d353] sm:h-3 sm:w-3"></div>
        </div>
        <span class="hidden sm:inline">More</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  const props = defineProps({
    username: {
      type: String,
      default: 'limo-git'
    }
  });

  const stats = ref({
    thisYear: '1.2k+',
    longestStreak: 45
  });

  const githubContributionUrl = computed(() => {
    return `https://ghchart.rshah.org/39d353/${props.username}`;
  });
</script>

<style scoped>
  .contribution-graph {
    backdrop-filter: blur(8px);
  }
</style>
